const site = site || {};
site.Utilities = (() => {
    // Functions

    // const functionName = () => {
    //
    // };

    const autocomplete = () => {

        // Create one global XHR object so we can abort old requests when a new one is made
        window.autocompleteXHR = new XMLHttpRequest()  

        // Set up autocomplete forms
        document.querySelectorAll('form[data-autocomplete-route]')
            .forEach(form => {
                const document = form.ownerDocument;
                const searchInputs = form.querySelectorAll('input[type="search"]');
                if (!searchInputs || !searchInputs[0]) return;

                const dataListId = searchInputs[0].getAttribute("list");
                const dataList = document.getElementById(dataListId);
                if (!dataList) return;

                // Add a keyup event listener to the search input element
                searchInputs[0].addEventListener("keyup", function (event) { autocomplete(event, form.dataset.autocompleteRoute, dataList) });
            });

        // Autocomplete for form
        function autocomplete(event, route, dataList) {

            // Retireve the input element
            var input = event.target;

            // Minimum number of characters before we start to generate suggestions
            var minCharacters = 0;

            if (input.value.length < minCharacters) {
                return;
            } else {

                // Abort any pending requests
                window.autocompleteXHR.abort();

                window.autocompleteXHR.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {

                        // We're expecting a json response so we convert it to an object
                        var response = JSON.parse(this.responseText);

                        // Clear any previously loaded options in the datalist
                        dataList.innerHTML = "";

                        response.forEach(function (item) {
                            // Create a new <option> element.
                            var option = document.createElement('option');
                            option.value = item;

                            // Attach the option to the datalist element
                            dataList.appendChild(option);
                        });
                    }
                };

                window.autocompleteXHR.open("GET", route + input.value, true);
                window.autocompleteXHR.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                window.autocompleteXHR.send();
            }
        }
    };

    const autocompleteSubmit = () => {
        const searchInput = document.querySelector('.js-table-search-input');
        const searchSubmit = document.querySelector('.js-table-search-submit');
        if (searchInput) {
            searchInput.addEventListener("change", (event) => {
                
                const inputValue = searchInput.value;
                
                const options = document.querySelectorAll('.js-table-search-suggestions option');
                
                options.forEach(option => {
                    const optionValue = option.value;
                    
                    if (optionValue == inputValue) {
                        searchSubmit.click();
                        return;
                    } 
                })
            });
        }
    }

    const resetTableView = () => {
        const resetButton = document.querySelector('.js-table-search-reset');
        const currentUrl = window.location.href;

        if(resetButton) {
            if(currentUrl.indexOf('?') != -1) {
                console.log('query string');
                resetButton.classList.remove('d-none')
            }
    
            resetButton.addEventListener('click', () => {
                const url = window.location.href.split("?")[0]
                window.location.href = url
            })
        }

    }

    const deleteItemModal = () => {
        const deleteTriggers = document.querySelectorAll('.js-delete');
        const deleteModalTitle = document.querySelector('.js-modal-title');
        const deleteModalFormId = document.querySelector('.js-delete-form-id');
        if (deleteTriggers) {
            deleteTriggers.forEach(trigger => {
                trigger.addEventListener('click', () => {
                    const itemName = trigger.dataset.itemName;
                    const itemId = trigger.dataset.itemId;
                    deleteModalTitle.textContent = itemName;
                    deleteModalFormId.value = itemId;
                })
            })
        }
    }

    function getCookieValue(name) {
        let result = document.cookie.match("(^|[^;]+)\s*" + name + "\s*=\s*([^;]+)")
        return result ? result.pop() : ""
    }

    const popToast = () => {
        const approvalForms = document.querySelectorAll('.js-submit-for-approval-form');
        const pendingChangesText = document.querySelector('.js-pending-changes')
        let toastClosed = getCookieValue('toastClosed')

        if (approvalForms) {
            approvalForms.forEach(form => {
                form.addEventListener('submit', () => {
                    document.cookie = "toastClosed=false"
                })
            })
        }
        if (pendingChangesText && toastClosed != "true") {
            const toast = document.querySelector('.js-submission-confirmation')
            const toastBootstrap = new bootstrap.Toast(toast, { autohide: false });
            toastBootstrap.show()

            setTimeout(() => {
                document.querySelector('.js-submitted-toast-close').addEventListener('click', (e) => {
                    e.stopPropagation();
                    document.cookie = "toastClosed=true"
                })
            }, 250);
        } 
    }

    const navCollapse = () => {
        const collapses = document.querySelectorAll('#sidebarCollapse .collapse');
        collapses.forEach(collapse => {
            const collapseInstance = new bootstrap.Collapse(collapse, {
                toggle: false
            });
            // Hide sibling collapses on `show.bs.collapse`
            collapse.addEventListener('show.bs.collapse', (e) => {
                e.stopPropagation();
                const closestCollapse = collapse.parentElement.closest('.collapse');
                const siblingCollapses = closestCollapse.querySelectorAll('.collapse');
                siblingCollapses.forEach(siblingCollapse => {
                    const siblingCollapseInstance = bootstrap.Collapse.getInstance(siblingCollapse);
                    if (siblingCollapseInstance === collapseInstance) {
                        return;
                    }
                    siblingCollapseInstance.hide(); 
                });
            });
            // Hide nested collapses on `hide.bs.collapse`
            collapse.addEventListener('hide.bs.collapse', (e) => {
                e.stopPropagation();
                const childCollapses = collapse.querySelectorAll('.collapse');
                childCollapses.forEach(childCollapse => {
                    const childCollapseInstance = bootstrap.Collapse.getInstance(childCollapse);
                    childCollapseInstance.hide();
                });
            });
        });
    }

    const copyToClipboard = () => {
        const clipboardCopyButtons = document.querySelectorAll('.js-clipboard-copy');

        if (clipboardCopyButtons) {
            const clipboardToast = document.querySelector('.js-clipboard-confirmation')
            const clipboardToastBootstrap = new bootstrap.Toast(clipboardToast, { delay: 2000 });
            const failureToast = document.querySelector('.js-failure-toast')
            const failureToastBootstrap = new bootstrap.Toast(failureToast, { delay: 2000 });
            
            clipboardCopyButtons.forEach(button => {
                button.addEventListener('click', () => {
                    let buttonText = button.textContent;
                    navigator.clipboard.writeText(buttonText).then(function () {
                        clipboardToastBootstrap.show()
                    }, function (err) {
                        failureToastBootstrap.show()
                    });
                })
            })
        }
    }

    // Return
    return {
        // functionName : functionName
        autocomplete: autocomplete,
        autocompleteSubmit: autocompleteSubmit,
        resetTableView: resetTableView,
        deleteItemModal: deleteItemModal,
        popToast: popToast,
        navCollapse: navCollapse,
        copyToClipboard: copyToClipboard
    };
})();